import React from 'react';
import _ from 'lodash';
import { useParameterizedQuery, useMutation, useQuery } from 'react-fetching-library';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableHead, TableRow, TableCell, TableBody, TableContainer, IconButton, Tooltip, CircularProgress, Typography, Modal, Card, CardHeader, CardContent, Stack } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import HistoryIcon from '@mui/icons-material/History';
import DeleteIcon from '@mui/icons-material/Delete';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import { CreatePayment, getRodzajPlatnosciString } from './tabs/OrderTab/CreatePayment';
import { updateOrder } from '../../../../services/redux-actions';
import { ConfirmDialog } from '../../../../components-core/ConfirmDialog';
import { PAYMENT_KINDS, PAYMENT_DIALOG_STYLE } from '../../../../utils/consts';

import { sendPaymentReminder, deletePayment, getPaymentAction } from '../../../../services/request';

function Row(props) {
  const dispatch = useDispatch();
  const [sent, setSent] = React.useState(false);
  const { userEmail } = useSelector(state => state.app);
  const [confirmDeleteToggleOpen, setConfirmDeleteToggleOpen] = React.useState(false);
  const [confirmSendPaymentAlert, setConfirmSendPaymentAlert] = React.useState(false);
  const [historyVisible, setHistoryVisible] = React.useState(false);
  const { mutate } = useMutation(deletePayment);
  const { query, loading } = useParameterizedQuery(sendPaymentReminder);
  const { query: queryGetPayment, loadingGetPayment } = useParameterizedQuery(getPaymentAction);
  const { row, order, handleEditPositon } = props;

  const handleSendPaymentAlertClick = async () => {
    const { error, loading } = await query(row.id);

    if (!error && !loading) {
      setSent(true);
    }
  };

  const handleDeleteToggle = async () => {
    row.deleted = !row.deleted;
    const { error, loading } = await mutate(row.id);
    if (!error && !loading) {
      const { payload, error } = await queryGetPayment(row.id);
      if (!error) {
        // console.log('udało się pobrać!');
        const updatedOrder = { ...order, order_payments: order.order_payments.map(payment => payment.id !== payload.id ? payment : payload) };
        dispatch(updateOrder(updatedOrder));
      }
    }
  };

  const typPlatnosci = [];
  const TPAY = 1;
  const PRZELEW = 2;
  const GOTOWKA = 3;
  typPlatnosci[TPAY] = 'tpay';
  typPlatnosci[PRZELEW] = 'prze';
  typPlatnosci[GOTOWKA] = 'got';

  let deletedContent = null;
  let stateIcon = (row.paid ? <CheckIcon color="success"/> : <ClearIcon color="error"/>);
  const skipDeductionIcon = (row.skip_deduction ? <AccountBalanceOutlinedIcon/> : null);
  let deletionFuture = null;

  if ((!row.paid || row.payment_type === GOTOWKA) && (userEmail === 'admin@example.com' || userEmail === 'll@jujitsumohikan.com.pl')) {
    deletionFuture = (<IconButton color="error" onClick={() => setConfirmDeleteToggleOpen(true)}><DeleteIcon/></IconButton>);
  }

  if (row.deleted) {
    deletedContent = (
      <Tooltip title="Usunięto, przywrócić?" placement="left-start"><IconButton color="error" onClick={() => setConfirmDeleteToggleOpen(true)}><RemoveCircleOutlineIcon color="disabled"/></IconButton></Tooltip>
    );
    stateIcon = (row.paid ? <CheckIcon color="disabled"/> : <ClearIcon color="disabled"/>);
  }

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell align="center">
          {getRodzajPlatnosciString(row)}{row.title}<br/>
          {historyVisible ? (
            <Typography variant="caption" gutterBottom align="right" style={{ whiteSpace: 'normal' }} >
              {row.recent_changes}
            </Typography>
          ) : ''}
        </TableCell>
        {/* <TableCell align="center">
          <Typography variant="caption" display="block">
            ES
          </Typography>
        </TableCell> */}
        <TableCell align="center">{row.to_pay}
          <Typography variant="caption">
            {row.paid ? ` [${typPlatnosci[row.payment_type]}]` : null}
          </Typography>
        </TableCell>
        <TableCell align="center">{stateIcon}{skipDeductionIcon}</TableCell>
        <TableCell align="center">
          <Stack direction="row">
            {loading
              ? <CircularProgress size={24}/>
              : (!row.paid && !row.deleted)
                ? <Tooltip title="Wyślij przypomnienie o płatności" placement="left-start">
                  <IconButton color="primary" onClick={sent ? () => {} : () => setConfirmSendPaymentAlert(true)} disabled={sent}>{sent ? <MarkEmailReadOutlinedIcon /> : <ForwardToInboxIcon />}</IconButton>
                </Tooltip> : null}
            {!row.deleted && <IconButton onClick={() => handleEditPositon(row)}><EditOutlinedIcon/></IconButton>}
            {/* {row.excess_payment ? <IconButton color="error" onClick={() => setConfirmDeleteOpen(true)}><DeleteIcon/></IconButton> : null} */}
            {!_.isNil(row.recent_changes) && <IconButton onClick={() => setHistoryVisible(!historyVisible)}><HistoryIcon/></IconButton>}
            {row.deleted ? deletedContent : deletionFuture}
          </Stack>
        </TableCell>
        {/* <TableCell align="center">
          {row.excess_payment ? <IconButton color="error" onClick={() => setConfirmDeleteOpen(true)}><DeleteIcon/></IconButton> : null}
          {row.deleted ? deletedContent : <IconButton color="error" onClick={() => setConfirmDeleteOpen(true)}><DeleteIcon/></IconButton>}
        </TableCell> */}
      </TableRow>
      <ConfirmDialog
        title={row.deleted ? 'Przywrócić płatność?' : 'Usunąć płatność?'}
        open={confirmDeleteToggleOpen}
        setOpen={setConfirmDeleteToggleOpen}
        onConfirm={handleDeleteToggle}
      >
        Czy na pewno chcesz {row.deleted ? 'przywrócić' : 'usunąć'} <b>{row.title}</b>?
      </ConfirmDialog>
      <ConfirmDialog
        title="Wysłać przypomnenie o płątności?"
        open={confirmSendPaymentAlert}
        setOpen={setConfirmSendPaymentAlert}
        onConfirm={handleSendPaymentAlertClick}
      >
        Czy na pewno chcesz wysłać przypomnienie o płatności <b>{row.title}</b>?
      </ConfirmDialog>
    </React.Fragment>
  );
}

export const Positions = props => {
  const [openModalEditPlatnosc, setOpenModalEditPlatnosc] = React.useState(false);
  const [positionToEdit, setPositionToEdit] = React.useState(null);

  const { positions, order, height = 220 } = props;
  // console.log('positions');
  // console.log(order);

  const handleEditPositon = position => {
    console.log('handleEditPositon');
    console.log(position);
    setPositionToEdit(position);
    setOpenModalEditPlatnosc(true);
  };

  const handleEditPositionModalClose = () => {
    setOpenModalEditPlatnosc(false);
    setPositionToEdit(null);
  };

  return (
    <>
      <TableContainer sx={{ width: '100%', height, overflow: 'auto' }}>
        <Table stickyHeader size="small" sx={{ width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell align="center">Nazwa</TableCell>
              {/* <TableCell align="center">Ost. zmiana</TableCell> */}
              <TableCell align="center">Kwota (zł)</TableCell>
              <TableCell align="center">Opłacone</TableCell>
              <TableCell align="center">Operacje</TableCell>
              {/* <TableCell align="center"></TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {positions.map(row => <Row key={row.id} row={row} order={order} handleEditPositon={handleEditPositon}/>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Modal
        open={openModalEditPlatnosc}
        onClose={() => setOpenModalEditPlatnosc(false)}>
        <Card sx={{ ...PAYMENT_DIALOG_STYLE, width: '500px' }}>
          <CardHeader title="Edytuj płatność" />
          <CardContent>
            <CreatePayment order={order} handleClose={handleEditPositionModalClose} positionToEdit={positionToEdit}/>
          </CardContent>
        </Card>
      </Modal>
    </>
  );
};
